// src/pages/ErrorPage.js

import React from 'react';
import { Link } from 'react-router-dom';
import '../css/spaPage.css';
import '../css/error.css';

function ErrorPage() {
    return (
        <div className="error-page-container">
            <div className="error-content">
                <h1 className="error-title">Oops!</h1>
                <p className="error-description">
                    Something went wrong while processing your request.
                </p>
                <p className="error-description">
                    Please try again or return to the homepage.
                </p>
                <Link to="/" className="error-button">
                    Go Home
                </Link>

                {/*<Link*/}
                {/*    to="/"*/}
                {/*    className="error-button"*/}
                {/*    onClick={() => window.location.reload()}*/}
                {/*>*/}
                {/*    Go Home*/}
                {/*</Link>*/}
            </div>
        </div>
    );
}

export default ErrorPage;
